import styled from '@emotion/styled';

const Header = styled.header`
  box-sizing: border-box;
  width: 100%;
  min-height: 56px;

  display: flex;
  align-items: center;
  gap: 4px;

  padding: 0 12px;

  @media (max-width: 1023px) {
    padding: 8px;
  }

  box-shadow: 0 2px 24px ${({ theme }) => theme.NeutralColorLightHigh};
  background: ${({ theme }) => theme.NeutralColorLightPure};
`;

const Lateral = styled.div`
  flex: 0 0 80px;

  @media (max-width: 1023px) {
    flex: 0 0 48px;
  }
`;

const TextoTruncado = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TituloWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const S = {
  Header,
  Lateral,
  TituloWrapper,
  TextoTruncado,
};

export default S;
